import React, { ReactNode, useEffect } from "react";
import i18n from "../i18n";
import { I18nextProvider } from "react-i18next";

interface LanguageWrapperProps {
    children: ReactNode;
    lng: string;
}

const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ children, lng }) => {
    useEffect(() => {
        if (lng && i18n.language !== lng) {
            i18n.changeLanguage(lng);
        }
    }, [lng]);

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default LanguageWrapper;
